export const decodeTempTokenExpiration = (tempToken: string): number | null => {
  try {
    const base64Url = tempToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join("")
    );
    const { exp } = JSON.parse(jsonPayload);
    return exp ? exp * 1000 : null;
  } catch {
    return null;
  }
};
